
import { defineComponent, ref } from 'vue';
import { useAdmins } from '../../modules';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Paginator from 'primevue/paginator';

export default defineComponent({
  components: {
    DataTable,
    Column,
    Paginator,
  },
  setup() {
    const adminModule = useAdmins();
    adminModule.manager.getCreatorsEarnings();
    const limit = ref(50);
    const skip = ref(0);

    const onPage = (event: { page: number; first: number; rows: number; pageCount: number }) => {
      skip.value = event.first;
      adminModule.manager.getCreatorsEarnings(
          limit.value,
          skip.value,
      );
    };

    return {
      onPage,
      data: adminModule.manager.getCreatorsEarningsResult,
      limit,
      skip,
    };
  },
})
